import { Field, ScrollableArea, TextAreaEditor } from '@approvalmax/ui';
import styled from 'styled-components';

import { SectionContainer } from '../../../components/SectionContainer';

export const Root = styled.div`
    display: flex;
    flex-flow: column;
    position: relative;
    height: 100%;
    width: 100%;
`;

export const Toolbar = styled.div`
    flex: none;
    padding: 25px 80px 30px 80px;
    border-bottom: 1px solid #cacccd;
    display: flex;
    align-items: center;
`;

export const ToolbarText = styled.div`
    flex: 1;
    font-weight: 600;
    font-size: 20px;
    color: #333;
    text-transform: uppercase;
`;

export const Content = styled(ScrollableArea)`
    flex: 1;
    overflow: hidden;
`;

export const ContentInner = styled.div`
    padding-bottom: 40px;
    display: flex;
    flex-flow: column;
`;

export const StyledField = styled(Field)`
    width: 267px;
    min-width: 267px;
    margin-bottom: 22px;
    margin-right: 30px;
`;

export const FieldsWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
`;

export const SectionContainerAligned = styled(SectionContainer)`
    align-items: flex-end;
`;

export const MemoEditor = styled(TextAreaEditor)`
    width: 565px;
`;

export const CurrencyField = styled(Field)`
    width: 267px;
    min-width: 267px;
`;
